// extracted by mini-css-extract-plugin
module.exports = {"popup":"DraggablePopup_popup__36EnM","buttons":"DraggablePopup_buttons__mfh-i","button":"DraggablePopup_button__2ziv1"};